var fn = function( obj ){
var __t,__p='';
__p+='#if __VERSION__ == 300\n    #define texture2D(a, b) texture( a, b )\n#endif\nuniform sampler2D uNoiseTex;\nuniform float uTime;\nuniform float uRadius;\nuniform float uDelay;';
return __p;
};
fn.toString=fn;
module.exports = fn;